import { useEffect, useState } from 'react'
import { TCanvas } from '../Canvas'

export type TWidgetPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topLeft'
  | 'centerLeft'
  | 'center'
  | 'centerRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'bottomCenter'

export const getLogoPositions = ({
  canvasConfig,
  widgetSize,
}: {
  canvasConfig: TCanvas
  widgetSize: {
    h: number
    w: number
  }
}) => {
  const borderOffset = 10

  const {
    height: canvasHeight,
    width: canvasWidth,
    bleedHeight,
    bleedWidth,
    safeZoneOffsets,
  } = canvasConfig

  const {
    top: safeZoneTop,
    right: safeZoneRight,
    bottom: safeZoneBottom,
    left: safeZoneLeft,
  } = safeZoneOffsets

  const totalLeftOffset = bleedWidth + borderOffset + (safeZoneLeft || 0)
  const totalTopOffset = bleedHeight + borderOffset + (safeZoneTop || 0)
  const totalRightOffset = bleedWidth + borderOffset + (safeZoneRight || 0)
  const totalBottomOffset = bleedHeight + borderOffset + (safeZoneBottom || 0)

  const totalCentralHorizontalOffset =
    (safeZoneLeft || 0) - (safeZoneRight || 0)
  const totalCentralVerticalOffset =
    (safeZoneTop || 0) / 2 - (safeZoneBottom || 0) / 2

  const positions = {
    topLeft: {
      x: totalLeftOffset,
      y: totalTopOffset,
    },
    topCenter: {
      x: canvasWidth / 2 - widgetSize.w / 2 + totalCentralHorizontalOffset,
      y: totalTopOffset,
    },
    topRight: {
      x: canvasWidth - widgetSize.w - totalRightOffset,
      y: totalTopOffset,
    },

    centerLeft: {
      x: totalLeftOffset,
      y: canvasHeight / 2 - widgetSize.h / 2 + totalCentralVerticalOffset,
    },
    center: {
      x: canvasWidth / 2 - widgetSize.w / 2 + totalCentralHorizontalOffset,
      y: canvasHeight / 2 - widgetSize.h / 2 + totalCentralVerticalOffset,
    },
    centerRight: {
      x: canvasWidth - widgetSize.w - totalRightOffset,
      y: canvasHeight / 2 - widgetSize.h / 2 + totalCentralVerticalOffset,
    },

    bottomLeft: {
      x: totalLeftOffset,
      y: canvasHeight - widgetSize.h - totalBottomOffset,
    },
    bottomCenter: {
      x: canvasWidth / 2 - widgetSize.w / 2 + totalCentralHorizontalOffset,
      y: canvasHeight - widgetSize.h - totalBottomOffset,
    },
    bottomRight: {
      x: canvasWidth - widgetSize.w - totalRightOffset,
      y: canvasHeight - widgetSize.h - totalBottomOffset,
    },
  }
  return positions
}
export function useLogoPosition({
  canvasConfig,
  widgetSize,
}: {
  canvasConfig: TCanvas
  widgetSize: {
    h: number
    w: number
  }
}) {
  const [logoPositions, setLogoPositions] =
    useState<Record<TWidgetPosition, { x: number; y: number }>>(null)

  useEffect(() => {
    if (!widgetSize?.w || !widgetSize?.h) {
      setLogoPositions(null)
      return
    }

    const positions = getLogoPositions({ canvasConfig, widgetSize })

    setLogoPositions(positions)
  }, [canvasConfig?.height, canvasConfig?.width, widgetSize])

  return logoPositions
}
